import React, { useState, useEffect } from 'react'
import "./Style.css"
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { getEarnings, getSurveyDetails, Pastsession } from '../Utils/utils'
import Loader from '../../Component/Loader/Loader'
import moment from 'moment'
import { FiSearch, FiChevronRight, FiChevronLeft } from "react-icons/fi";

const Earnings = () => {
  const [Loading, setLoading] = useState(false);
  const [detail, setDetail] = useState([]);
  const [finalEarn, setFinalEarn] = useState('');
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0)
  const [count, setCount] = useState(10)
  const [totalEarn, setTotalEarn] = useState('');

  const surveyDetailing = async () => {
    try {
      setLoading(true)
      const response = await getEarnings(page, count);
      setFinalEarn(response.data?.final_earnings)
      setTotalEarn(response.data?.total_earnings)
      setTotalPage(response.metadata?.totalPage)
      setDetail(response.data.data)
    } catch (error) {
      console.error("Error during Dashboard request:", error);
    } finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    surveyDetailing();
  }, [page]);

  return (
    <>
      {Loading && <Loader />}
      <div className="Passbooking-top">
        <div className='booking-wrapper mx-auto'>
          <div className='booking-top-container p-4'>
            <Link to="/dashboard" style={{ textDecoration: 'none' }}>
              <img
                className="img-fluid left-arrow-img"
                src="./Images/left-arrow.svg"
                alt="arrow"
              />
            </Link>

            <span className='title d-flex align-items-center justify-content-center mt-3'>Earnings</span>
          </div>

          <div className='pastbooking-info p-3 pad-top'>
            {/* Past Bookings */}
            <div className='earn-date-2'>Total Earnings: ₹{finalEarn == null ? totalEarn : finalEarn}</div>
            {/* <div className='earn-date'>: ₹5,000</div> */}
            {/* <div className='earn-date'>Total Earnings: ₹5,000</div> */}
            {detail && detail.map((det) => (
              <div className='earn-box'>
                <div className='row w-100 m-auto'>
                  <div className='col p-0 pe-2'>
                    <div className='earn-date'>{moment(det?.craetedAt).format(`DD MMM 'YY`)}</div>
                    <div className='earn-name'>
                      {det?.member?.name ? det?.member?.name : det?.member?.full_name}
                    </div>
                  </div>
                  <div className='col-auto p-0'>
                    <div className='earn-date'>₹{det?.total_amount}</div>
                  </div>
                </div>
              </div>
            ))}


            {totalPage > 1 &&
              <div className='w-100 row m-auto mt-3' style={{ justifyContent: 'end' }}>
                {page > 1 &&
                  <div className='arrow-style' style={{ paddingRight: '8px' }} onClick={() => {
                    setPage(page - 1)
                  }}>
                    <FiChevronLeft size={"20px"} color='#666666' />
                  </div>}
                {Array.from({ length: totalPage }, (_, index) => (
                  <div className={page == index + 1 ? `btm-number-selected` : `btm-number`} onClick={() => setPage(index + 1)}>{index + 1}</div>
                ))}
                {page != totalPage &&
                  <div className='arrow-style' onClick={() => {
                    setPage(page + 1)
                  }}>
                    <FiChevronRight size={"20px"} color='#666666' />
                  </div>}
              </div>
            }


          </div>
        </div>
      </div>
    </>


  )
}

export default Earnings